/**
 * Meeting context - the deal's living "last meeting recap + next meeting prep" artifact, plus the
 * per-document processing activity log shapes (Docs tab).
 *
 * The PAYLOAD is AI-generated server-side (apps/api meeting-context service) and validated against
 * `meetingContextPayloadSchema`; every item cites the documents it came from via `sourceRefs`
 * (documentUuid = knowledge.document external ref - same provenance unit as ScopeSourceRef, minus
 * the quote). The ACTIVITY shapes describe the persisted per-doc processing log
 * (sales.deal_doc_activity): one `doc_processed` summary event per processed doc per apply batch,
 * plus per-question child events; user actions (delete/merge) log doc-less events.
 */
import { z } from 'zod';
// ── Meeting-context payload (AI-generated, Zod-validated) ────────────────────
export const meetingContextRefSchema = z.object({
    documentUuid: z.string().min(1),
    documentTitle: z.string().optional(),
});
export const meetingContextItemSchema = z.object({
    text: z.string().min(1).max(600),
    sourceRefs: z.array(meetingContextRefSchema).max(4).default([]),
});
export const meetingContextPayloadSchema = z.object({
    /** Last-meeting context: topics discussed, decisions, scope changes. */
    summaryNotes: z.array(meetingContextItemSchema).max(20),
    /** Next-meeting prep: open questions, promised items. */
    followUps: z.array(meetingContextItemSchema.extend({ done: z.boolean().optional() })).max(20),
});
//# sourceMappingURL=meeting-context.js.map